<template>
  <AllRecordsTable
    submit-button-text="Добавить проект"
    table-name="projects"
    link-slug="projects"
    title="Проекты"
    :columns="projectsTable.columnNames"
    :row-links="projectsTable.rowLinks"
    :filter-fields="projectsTable.filterFields"
    :order-fields="projectsTable.orderFields"
    :rows="projectsTable.rowNames"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from "@/stock/constants";
export default {
  components: {
    AllRecordsTable,
  },
  data() {
    return {
      projectsTable: lists.projects,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/AllProjectsPage.vue